import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseFormSetError } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { t } from "ttag";

import { ADMIN_ROUTES } from "@/app/router";
import { errorToast, useToastStore } from "@/shared/ui";
import { handleAxiosFieldErrors } from "@/shared/utils";
import { coachingQueriesStore, createSession } from "../api";
import type { CreateSession } from "../models";

export const useCreateSession = (
  setError: UseFormSetError<Omit<CreateSession, "published">>,
) => {
  const pushToast = useToastStore((state) => state.pushToast);

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createSession,
    onSuccess: () => {
      void pushToast({
        type: "success",
        title: t`Success`,
        message: t`Session successfully created!`,
      });

      void queryClient.invalidateQueries({
        queryKey:
          coachingQueriesStore.coaching.admin._ctx.session._ctx.list._def,
      });

      navigate(ADMIN_ROUTES.COACHING.BASE);
    },
    onError: (error) => {
      errorToast(error);
      handleAxiosFieldErrors(error, setError);
    },
  });
};
